import { render, staticRenderFns } from "./LiffCardSetting.vue?vue&type=template&id=4ed64664&"
import script from "./LiffCardSetting.vue?vue&type=script&lang=js&"
export * from "./LiffCardSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports